module.exports = __webpack_public_path__ + "media/dragon_breath.600c1f3f.mp3";